import { useQuery } from '@tanstack/react-query';

import { rpcClient } from '../lib/orpc.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business 保有中の全アイテム（FKU単位）を取得するReact Queryフック。元データは日次更新のため staleTime を長めに取る。
 * @graph-connects rpcClient [calls] oRPC itemCatalog.list 呼び出し
 */
export function useItemCatalog() {
  return useQuery({
    queryKey: queryKeys.itemCatalog.all,
    queryFn: () => rpcClient.itemCatalog.list(),
    staleTime: 30 * 60_000,
    retry: false,
  });
}
